<template>
  <div class="col-sm-12 routa-light">
    <h1 class="title blue">{{ $t('menu.why') }}</h1>
    <b-row class="reference-container" align-h="center">
      <div class="col-sm-2 check">
        <font-awesome-icon icon="check"/>
      </div>
      <div class="col-sm-4 benefit">
        {{ $t('why.cost') }}
      </div>
      <div class="col-sm-2 check">
        <font-awesome-icon icon="check"/>
      </div>
      <div class="col-sm-4 benefit">
        {{ $t('why.easy') }}
      </div>
    </b-row>
    <b-row class="reference-container" align-h="center">
      <div class="col-sm-2 check">
        <font-awesome-icon icon="check"/>
      </div>
      <div class="col-sm-4 benefit">
        {{ $t('why.multipurpose') }}
      </div>
      <div class="col-sm-2 check">
        <font-awesome-icon icon="check"/>
      </div>
      <div class="col-sm-4 benefit">
        {{ $t('why.custom') }}
      </div>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Why',
}
</script>

